import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useTheme } from "@hooks/use-theme.ts";

export const Route = createRootRoute({
  component: () => {
    useTheme();

    return (
      <>
        <Outlet />
        <TanStackRouterDevtools />
      </>
    );
  },
});
